import { SelectBoxOption } from 'sos-common/js';
import { IOccupation } from '../../models/occupation.model';
import { ResourceItem } from 'sos-common/js/commonTypes';
import { InfoBlockModel } from '../../models/view.models';

export interface IPreAnsokanProps {
  queryYrkesId: string;
  occupationDefaultOptionText: string;
  occupationList: SelectBoxOption[];
  whereEducation: string;
  applyForLeg: string;
  noEducationHeading: string;
  noEducationBody: string;
  workedThreeYears: string;
  pageLanguage: string;
  translations: ResourceItem[];
  activeIds: string[];
  warning: InfoBlockModel;
}

export interface IPreAnsokanState {
  visibilityMap: Map<Section, boolean>;
  activeOccupation: string;
  occupationModel: IOccupation;
  isLoading: boolean;
  showSpinner: boolean;
}

export enum Section {
  NoOccupationInList,
  WhereEducationChoice,
  EducationInSwe,
  EducationInEu,
  EducationInWorld,
  HaveWorkedThreeYears,
  HaveNotWorkedThreeYears,
  ProtectedOccupationTitle,
}

export const ALL_SECTIONS = [
  Section.NoOccupationInList,
  Section.WhereEducationChoice,
  Section.EducationInSwe,
  Section.EducationInEu,
  Section.EducationInWorld,
  Section.HaveWorkedThreeYears,
  Section.HaveNotWorkedThreeYears,
  Section.ProtectedOccupationTitle,
];
